/* Partner links: ?ref=<code> on any page is remembered for 60 days on this device and saved on the
   basket as the order detail "Partner". No discount and nothing is shown to the buyer. The last link
   opened wins. A code is 2 to 40 characters: lowercase letters, digits and hyphens.
   Restored 1 Nov 2026 (Website chat helper) from the old live theme 207649341788 assets/rn-v5-shop.js,
   unchanged in behaviour; wrapped in try/catch so it can never throw into the page or hold up a form. */
(() => {
  try {
    const KEY = 'rn_partner';
    const MAX_AGE = 60 * 864e5;
    const clean = (value) => {
      const code = String(value || '').trim().toLowerCase();
      return /^[a-z0-9][a-z0-9-]{1,39}$/.test(code) ? code : '';
    };
    let saved = null;
    try { saved = JSON.parse(window.localStorage.getItem(KEY) || 'null'); } catch (e) {}
    let fromLink = '';
    try { fromLink = clean(new URLSearchParams(window.location.search).get('ref')); } catch (e) {}
    if (fromLink) saved = { code: fromLink, at: Date.now() };
    if (!saved || !clean(saved.code) || Date.now() - Number(saved.at || 0) > MAX_AGE) {
      try { window.localStorage.removeItem(KEY); } catch (e) {}
      return;
    }
    try { window.localStorage.setItem(KEY, JSON.stringify(saved)); } catch (e) {}
    const save = () => fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { Partner: saved.code } })
    }).catch(() => {});
    /* The basket is replaced after each order, so check it on every page rather than trusting a flag. */
    const sync = () => fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => { if (!cart.attributes || cart.attributes.Partner !== saved.code) return save(); })
      .catch(() => {});
    try { window.rnPartnerReady = sync(); } catch (e) {}
    /* Synchronous, no preventDefault: the hidden field is added and the submit carries on as normal. */
    document.addEventListener('submit', (event) => {
      try {
        const form = event.target;
        if (form && form.matches && form.matches('form[action*="/cart"]') && !form.querySelector('input[name="attributes[Partner]"]')) {
          const input = document.createElement('input');
          input.type = 'hidden'; input.name = 'attributes[Partner]'; input.value = saved.code;
          form.appendChild(input);
        }
      } catch (e) {}
    }, true);
  } catch (e) {}
})();
